import { Component } from "react"

class R18DisplayFlag extends Component{
    constructor(props){
        super(props)
        this.name = "R18指定作品の表示"
    }
    validate(callbackDialog){
        if(String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(!(this.props === "1" || this.props === "2")){
            callbackDialog("エラー",this.name + "は「表示する」または「表示しない」を選択してください。")
            return false
        }
        return true
    }
}

export default R18DisplayFlag;